export default __webpack_public_path__ + "static/media/featureIcon_placeholder.c9195e6a.png";